// extracted by css-extract-rspack-plugin
export default {"body":"Op22S2wSbO0h67mc","error":"rEmLU3XzWwdR0jvZ"};